import get from 'lodash.get';
import { Variety } from 'services/varieties/types';
import { CommoditiesState } from 'services/commodities/types';
import {
    VirtualizedTableItem,
    VirtualizedTableColumns
} from 'services/virtualizedTable/types';
import { selectVarietiesArray } from 'services/varieties/selectors';
import {
    FIELD_TYPE_STRING,
    FIELD_TYPE_DROPDOWN
} from 'components/VirtualizedTable/constants';
import { makeSelectTableColumnWidths } from 'services/columnWidths/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import formatDropdownOptions from 'utils/format-dropdown-options';

// @ts-ignore
import { selectCommodities } from 'services/commodities/selectors';

const selectCommodityOptions = createDeepEqualSelector(
    selectCommodities,
    (commodities: CommoditiesState) =>
        formatDropdownOptions(commodities, {
            keyField: 'id',
            textField: ({ name }) => name
        })
);

export const selectVarietiesTableColumns = createDeepEqualSelector(
    [makeSelectTableColumnWidths(), selectCommodityOptions],
    (tableColumnWidths, commodityOptions) => {
        const result: VirtualizedTableColumns = [
            {
                label: 'Commodity',
                value: 'commodityId',
                width: 200,
                type: FIELD_TYPE_DROPDOWN,
                options: commodityOptions,
                disableUpdating: true,
                validators: 'isRequired'
            },
            {
                label: 'Name',
                value: 'name',
                width: 250,
                type: FIELD_TYPE_STRING,
                validators: 'isRequired'
            },
            {
                label: 'Short Name',
                value: 'shortName',
                width: 250,
                type: FIELD_TYPE_STRING,
                validators: ['isRequired', 'isShortName'],
                fieldProps: {
                    maxLength: 2
                }
            },
            {
                label: 'Code',
                value: 'code',
                width: 250,
                type: FIELD_TYPE_STRING,
                emptyValueToNull: true
            }
        ];

        return result.map((column) => {
            const { width, value } = column;
            return {
                ...column,
                width: get(tableColumnWidths, value, width)
            };
        });
    }
);

export const selectVarietiesItems = createDeepEqualSelector(
    selectVarietiesArray,
    (varietiesArray) =>
        varietiesArray.map(
            (variety: Variety): VirtualizedTableItem => ({
                key: variety.uuid,
                id: variety.id,
                commodityId: variety.commodityId,
                name: variety.name,
                shortName: variety.shortName,
                code: variety.code
            })
        )
);
